import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=d51f67ca&lang=css"

const __exports__ = script;

export default __exports__